"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Serbian localization
 */
exports.default = {
    didNotBackUpWallet: 'Ako niste napravili rezervnu kopiju svog sertifikata ili ste izgubili telefon, kontaktirajte podršku @TicketheadSupport.',
    nft: 'Head',
};
//# sourceMappingURL=sr.js.map